import { Injectable } from "@angular/core";
import { Firestore, doc, getDoc } from "@angular/fire/firestore";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthSyndicateService } from "@core/AuthServices/authSyndicate/auth-syndicate.service";
import { CatchErrorService } from "@core/catch-error.service";
import { TranslateService } from "@ngx-translate/core";
import { finalize, firstValueFrom } from "rxjs";
import { CommonService } from "src/app/services/common/common.service";
import { PaymentService } from "src/app/services/payment.service";
import { v4 as uuidv4 } from "uuid";
import { StoreRepositoryService } from "../../store-repository.service";
import { AddCardComponent } from "../add-card.component";

@Injectable()
export class CardOfferService {
  constructor(
    private paymentService: PaymentService,
    private authService: AuthService,
    private catchService: CatchErrorService,
    private AuthSyndicateService: AuthSyndicateService,
    private storeService: StoreRepositoryService,
    private firestore: Firestore,
    private commonService: CommonService,
    private translate: TranslateService,
  ) {}

  cardOfferDisabled(componentContext: AddCardComponent, index: number): boolean {
    return componentContext.activeCardIndex.includes(index);
  }

  getCheckCardDetailId(componentContext: AddCardComponent) {
    if (!componentContext.storedCards) return;
    return componentContext.selectedCardData;
  }

  cardOfferPayment(componentContext: AddCardComponent, item: Data, index: number) {
    if (componentContext.processingStates.length < componentContext.promotions.length) {
      componentContext.processingStates = Array(componentContext.promotions.length).fill(false);
    }

    // Set the processing state to true for the clicked card
    componentContext.processingStates[index] = true;

    setTimeout(() => {
      componentContext.processingStates[index] = false;
      componentContext.next();
    }, 4000);

    componentContext.cardOfferDetails.forEach((cardoffer: Data) => {
      if (cardoffer.offerid === item.offer_id) {
        componentContext.cardOfferpurchaseDetail = cardoffer;
        componentContext.currentOfferCard = item.product_title;
        componentContext.updatedSuccessToast = componentContext.successToast.replace(
          "[product_title]",
          componentContext.currentOfferCard,
        );
        componentContext.updatedFailureToast = componentContext.failToast.replace(
          "[product_title]",
          componentContext.currentOfferCard,
        );
        this.cardofferProceedToPay(componentContext, index);
      }
    });
  }

  cardofferProceedToPay(componentContext: AddCardComponent, index: number) {
    componentContext.cardOfferpurchaseDetail.prosub_id = componentContext.prosub_id
      ? componentContext.prosub_id
      : localStorage.getItem("prosub_id")
        ? localStorage.getItem("prosub_id")
        : "";

    componentContext.cardOfferpurchaseDetail.tp1 = "OrderConfirmationBanner";
    componentContext.cardOfferpurchaseDetail.tp2 = "ProductPromo";
    componentContext.cardOfferpurchaseDetail.tp3 = componentContext.tp3
      ? componentContext.tp3
      : localStorage.getItem("TP3")
        ? localStorage.getItem("TP3")
        : "";

    componentContext.cardOfferpurchaseDetail.t_id = componentContext.t_id
      ? componentContext.t_id
      : localStorage.getItem("T_ID")
        ? localStorage.getItem("T_ID")
        : "";

    componentContext.cardOfferpurchaseDetail.upsell_id = componentContext.upsell_ID
      ? componentContext.upsell_ID
      : localStorage.getItem("upsell_ID")
        ? localStorage.getItem("upsell_ID")
        : "";

    componentContext.cardOfferpurchaseDetail.paymentOfferID = componentContext.paymentOfferID
      ? componentContext.paymentOfferID
      : localStorage.getItem("paymentOfferID")
        ? localStorage.getItem("paymentOfferID")
        : "";

    componentContext.cardOfferpurchaseDetail.other = componentContext.other
      ? componentContext.other
      : localStorage.getItem("Other")
        ? localStorage.getItem("Other")
        : "";

    componentContext.cardOfferpurchaseDetail.checkout = true;
    componentContext.cardOfferpurchaseDetail.selectedLines = componentContext.cardOfferpurchaseDetail.lines;
    componentContext.cardOfferpurchaseDetail.prize =
      componentContext.cardOfferpurchaseDetail.int_price[componentContext.preferredCurrency];

    const offerId: string = componentContext.cardOfferpurchaseDetail.offerid;
    componentContext.cardOfferpurchaseDetail.offers = {};
    componentContext.cardOfferpurchaseDetail.offers.offerid = componentContext.cardOfferpurchaseDetail.offerid;
    componentContext.cardOfferpurchaseDetail.offers.id = offerId;
    componentContext.cardOfferpurchaseDetail.offers.price = parseFloat(componentContext.cardOfferpurchaseDetail.price);

    this.paymentService
      .insertCustomerPurchase(
        { ...componentContext.cardOfferpurchaseDetail, ...componentContext.latestCardData },
        "/api_post_request/insert_customer_purchase_store_payment",
      )
      .subscribe(
        (result: Data) => {
          if (result?.status === "rejected") {
            this.authService
              .getConstantsMsg(result?.error_code)
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                this.catchService.logError("Error fetching constants message:", error);
              });
            this.stopSpinner(componentContext);
            return;
          }

          const customerPurchaseId = result?.response?.customer_purchase_id;
          const encryptedCustomerPurchaseId = result?.response?.encrypted_customer_purchase_id;
          this.paymentService.cashPurchaseCustomerPurchaseId$.next(encryptedCustomerPurchaseId);

          if (result && result?.response && result?.response?.status === "SUCCESS") {
            this.paymentService
              .processCardPayment(
                result?.response?.customer_purchase_id,
                componentContext.latestCardData,
                "/api_post_request/process_store_payment_existing_card",
              )
              .pipe(
                finalize(() => {
                  setTimeout(() => {
                    let pType = localStorage.getItem("payType");
                    let startTime = new Date();
                    let endTime = new Date();
                    let dwellTime = endTime.getTime() - startTime.getTime();
                    let formattedDwellTime = this.AuthSyndicateService.convertMillisecondsToTime(dwellTime);
                    const destinationUrl =
                      pType === "cash"
                        ? `${window.location.origin}/mainTabs/tabs/syndicate`
                        : pType === "cash-issue"
                          ? `${window.location.origin}/mainTabs/tabs/store`
                          : `${window.location.origin}/mainTabs/tabs/syndicate`;
                    componentContext.eventbody = {
                      Lottery_Product: componentContext.data?.real_name || "",
                      Dwell_Time: formattedDwellTime,
                      Payment_Method: componentContext.data?.offers?.payment_type || "",
                      Draw_Days: componentContext.data?.offers?.draw_day || "",
                      Line_Count: componentContext.data?.offers?.lines || 0,
                      Total_Amount: componentContext.data?.offers?.price || 0,
                      Journey_ID: componentContext.journeyId,
                      For_how_many_weeks:
                        componentContext.data?.selectedDiscount?.title === "No extension"
                          ? "Only once"
                          : componentContext.data?.selectedDiscount?.title || "",
                      Extension_Period: componentContext.data?.selectedDiscount?.title || "",
                      Pre_Existing_Card: componentContext.cardArrlength ? "Yes" : "No",
                      CTA: "Pay now",
                      P_Type: componentContext.selectedCard,
                      Destination_URL: destinationUrl,
                    };
                    this.stopSpinner(componentContext);
                  }, 1500);
                }),
              )
              .subscribe(
                (processPayResult: Data) => {
                  if (!processPayResult) return;
                  if (processPayResult?.status === "rejected") {
                    this.authService
                      .getConstantsMsg("")
                      .then((translatedMsg) => {
                        const defaultMsg = {
                          message: {
                            line_1: componentContext.updatedFailureToast,
                            line_2: "",
                          },
                          style: {
                            icon: "tick circle error.svg",
                            type: "Error",
                          },
                        };
                        this.authService.showToastMessage(translatedMsg, defaultMsg);
                      })
                      .catch((error) => {
                        this.catchService.logError("Error fetching constants message:", error);
                      });
                    return;
                  }
                  if (
                    processPayResult &&
                    processPayResult?.response &&
                    processPayResult?.response?.status === "SUCCESS"
                  ) {
                    componentContext.activeCardIndex.push(index);
                    this.authService
                      .getConstantsMsg("")
                      .then((translatedMsg) => {
                        const defaultMsg = {
                          message: {
                            line_1: componentContext.updatedSuccessToast,
                            line_2: "",
                          },
                          style: {
                            icon: "tick circle success.png",
                            type: "Success",
                          },
                        };
                        this.authService.showToastMessage(translatedMsg, defaultMsg);
                      })
                      .catch((error) => {
                        this.catchService.logError("Error fetching constants message:", error);
                      });

                    componentContext.isPaymentDone = true;
                    componentContext.proceed = false;
                    componentContext.responseObject = {
                      ...componentContext.purchaseDetail,
                      ...processPayResult?.response,
                      p_type: "10",
                    } as Data;
                    const myuuid = uuidv4();
                    const paymentDocId = String(myuuid);
                    const path_id = "At4Vyy58QQ2vknYAhw7T";
                    const doc_data = {
                      payment_response: componentContext.responseObject,
                      customer_purchase_id: customerPurchaseId,
                    };
                    const dv = { docId: paymentDocId };
                    const method = "update";

                    this.authService
                      .getV2CloudFunction("updatefirestoredoc", {
                        path_id,
                        doc_data,
                        dv,
                        method,
                      })
                      .subscribe({
                        error: (err) => {
                          this.catchService.logError("Error in cardofferProceedToPay:", err);
                        },
                      });
                    this.paymentService.updatePaymentReference(customerPurchaseId, paymentDocId).subscribe(
                      (res) => {
                        componentContext.displayResponse = res;
                      },
                      (err) => {
                        this.catchService.logError("Error updating payment reference:", err);
                      },
                    );
                    if (processPayResult.response?.syndicate_id) {
                      this.paymentService.updateSyndicateRequest(
                        componentContext.responseObject,
                        processPayResult.response?.syndicate_id,
                      );
                    }
                  } else {
                    this.authService
                      .getConstantsMsg("1050")
                      .then((translatedMsg) => {
                        const defaultMsg = {
                          message: {
                            line_1: "Failed in processing payment",
                            line_2: "",
                          },
                          style: {
                            icon: "tick circle error.svg",
                            type: "Error",
                          },
                        };
                        this.authService.showToastMessage(translatedMsg, defaultMsg);
                      })
                      .catch((error) => {
                        this.catchService.logError("Error fetching constants message:", error);
                      });
                  }
                },
                (err) => {
                  this.catchService.logError("Error processing payment:", err);
                },
              );
          } else {
            this.stopSpinner(componentContext);
            this.authService
              .getConstantsMsg("1051")
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Failed to make payment request",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                this.catchService.logError("Error fetching constants message:", error);
              });
          }
        },
        (err) => {
          this.catchService.logError("Error inserting customer purchase:", err);
        },
      );
  }

  async fetchOrderData(componentContext: AddCardComponent) {
    try {
      // ✅ Await UID properly instead of subscribe
      const uid = await firstValueFrom(this.commonService.getUid("add-card-component"));
      const path = `users/${uid}`;

      // ✅ Get user document
      const userDocRef = doc(this.firestore, path);
      const docSnapshot = await getDoc(userDocRef);

      if (!docSnapshot.exists()) {
        throw new Error(`No document found at path: ${path}`);
      }

      const data = docSnapshot.data() as Data;
      if (!data) {
        throw new Error("Data is undefined or null.");
      }

      // ✅ Get promotions by language_currency
      const languageCurrency = data.language_currency || "en_gbp";
      const cardOfferData = await this.storeService.getCardOfferDetails(languageCurrency);
      componentContext.promotions = cardOfferData.promotions || [];

      // ✅ Fetch offer details one by one
      for (const promotion of componentContext.promotions) {
        try {
          const res = await firstValueFrom(this.authService.getOfferDetail(promotion.offer_id));
          componentContext.cardOfferDetails.push(res);
        } catch (err) {
          this.catchService.logError(`Error fetching offer detail for ${promotion.offer_id}:`, err);
        }
      }

      // ✅ Translate toast messages
      this.translate.get(["store-payment.suggested-fail-toast", "store-payment.suggested-success-toast"]).subscribe({
        next: (res: Data) => {
          if (!res) return;
          componentContext.successToast = res["store-payment.suggested-success-toast"];
          componentContext.failToast = res["store-payment.suggested-fail-toast"];
        },
        error: (err) => {
          this.catchService.logError("Error translating toast messages:", err);
        },
      });
    } catch (error) {
      this.catchService.logError("Error fetching order data:", error);
      return error;
    }
  }

  startCountdown(componentContext: AddCardComponent) {
    const interval$ = setInterval(() => {
      if (componentContext.timeLeft > 0) {
        componentContext.timeLeft--;
        componentContext.expiry_in_minutes = Math.floor(componentContext.timeLeft / 60);
        componentContext.seconds = componentContext.timeLeft % 60;
      } else {
        clearInterval(interval$);
      }
    }, 1000);

    // Store interval ID if needed for cleanup
    componentContext.countdownInterval = interval$;
  }

  private stopSpinner(componentContext: AddCardComponent) {
    componentContext.progressBar = 100;
    componentContext.sub?.unsubscribe();
    componentContext.spinnerAnimation = false;
    componentContext.proceed = true;
    componentContext.changeDetRef.detectChanges();
  }
}
